import { z } from 'zod';

export const cableRouteSchema = z.object({
  text: z.string().min(1),
  location: z.string(),
});

export type CableRouteSchema = z.infer<typeof cableRouteSchema>;
